import { TableHeading } from "../../../../../components/common/table/TableDesign";
import { FormFieldProps } from "../../../../../utils/formFields";

export const tableHeadings: TableHeading[] = [
  { label: "Inventory Id",align: "left" },
  { label: "# of Items", align: "left" },
  { label: "Status", align: "left" },
  { label: "Date Created", align: "left" },
  { label: "", align: "center" },
];


export const tableSurveyHeadings: TableHeading[] = [
  { label: "Tag" },
  { label: "Article", align: "left" },
  { label: "Qty", align: "left" },
  { label: "Condition", align: "left" },
  // { label: "Create", align: "center" },
  { label: "Photos", align: "center" },
];

export const InvSurveyItemData = [
  {
    tag: "1",
    article: "Kitchenware",
    qty: "1",
    condition: "PBO",
    crate:'-',
    photo:''
  },
   {
    tag: "2",
    article: "Kitchenware",
    qty: "1",
    condition: "PBO",
    crate:'-',
    photo:''
  },
   {
    tag: "3",
    article: "Kitchenware",
    qty: "1",
    condition: "PBO",
    crate:'-',
    photo:''
  },
   {
    tag: "4",
    article: "Kitchenware",
    qty: "1",
    condition: "PBO",
    crate:'-',
    photo:''
  },
];


export const JobDetails = {
  job_id: "1004056",
  customer: "Paul Brzoska",
  origin: "Oakville, ON",
  destination: "Belfast, UK",
  date: "04 Aug 2025",
  tag: "1-37",
};

export const CODE_OPTIONS = [
  { id: "INC", name: "INC" },
  { id: "PBO", name: "PBO" },
  { id: "MS", name: "Ms" },
  { id: "BR", name: "BR" },
];

export const INVENTORY_FORM_ELEMENTS = [
  {
    id: "ref",
    label: "Tag/Ref",
    type: "text",
    md: 3,
    placeholder: "Enter Ref",
  },
  {
    id: "item_name",
    label: "Item Name",
    type: "text",
    md: 9,
    placeholder: "Enter Item Name",
  },
  { id: "qty", label: "Qty", type: "number", md: 3 },
  {
    id: "condition_code",
    label: "Condition Codes",
    type: "select",
    md: 2,
    options: CODE_OPTIONS,
  },
];

export const CREW_ITEM_TABLE_HEADINGS: TableHeading[] = [
  { label: "Tag/Ref", align: "left" },
  { label: "Item Name", align: "left" },
  { label: "Qty", align: "left" },
  { label: "Condition", align: "left" },
  // { label: "Crate Ref", align: "left" },
  { label: "Photos", align: "center" },
];

export const conditionOptions = ["INC", "PBO", "MS", "BR"];

export interface CrewInventoryItemFormData {
  ref_id: string;
  title: string;
  quantity: string;
  condition_code: string;
  photo_key: string;
}

export interface InventoryPayloadItem {
  ref_id?:string;
  survey_item_id?:string | null;
  id?: string;
  title: string;
  quantity: number;
  condition_code: string;
  photo_key: string;
  status: string;
  notes: string;
}

export interface CrewInventoryFormData {
  status?: string;
  customer_sign: string;
  driver_sign_pickup: string;
  driver_sign_delivery: string;
  items: InventoryPayloadItem[];
}

export const initialItemFormData: CrewInventoryItemFormData = {
  ref_id: "1",
  title: "",
  quantity: "1",
  condition_code: "PBO",
  photo_key: "",
};

export const initialCrewInventoryFormData: CrewInventoryFormData = {
  status: "DRAFT",
  customer_sign: "",
  driver_sign_pickup: "",
  driver_sign_delivery: "",
  items: [],
};

export const crewItemFormFields: FormFieldProps[] = [
  {
    id: "ref_id",
    label: "Ref ID - Sl No.",
    type: "text",
    disabled: true,
    md: 3,
  },
  { id: "title", label: "Item name", type: "text", isRequired: true, md: 5 },
  { id: "quantity", label: "Quantity", type: "number", isRequired: true, md: 2 },
  {
    id: "condition_code",
    label: "Condition Codes",
    type: "select",
    options: conditionOptions,
    md: 2,
  },
];

export const crewSignatureFields: FormFieldProps[] = [
  { id: "customer_sign", label: "Customer sign", type: "text", md: 6 },
  {
    id: "driver_sign_pickup",
    label: "Driver sign at pick up",
    type: "text",
    md: 6,
  },
];

export type CrewInventoryRequiredField = "title" | "quantity" | "driver_sign_pickup";
